import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AgreementDto } from '@models/users/agreement.dto';
import { environment } from '@environments/environment.prod';

@Injectable({
  providedIn: 'root',
})
export class AgreementService {
  constructor(private http: HttpClient) {}

  getAgreements() {
    return this.http.get<AgreementDto[]>(environment.host + '/agreements/list');
  }

  getAgreementView() {
    return this.http.get<AgreementDto[]>(environment.host + '/agreements/view');
  }

  createAgreement(subs: AgreementDto[]) {
    return this.http.post<AgreementDto[]>(
      environment.host + '/agreements/create',
      subs,
    );
  }

  modifyAgreement(subs: AgreementDto[]) {
    return this.http.post<AgreementDto[]>(
      environment.host + '/agreements/modify',
      subs,
    );
  }

  removeAgreement(subs: AgreementDto[]) {
    return this.http.post<AgreementDto[]>(
      environment.host + '/agreements/remove',
      subs,
    );
  }

  uploadAgreementPoster(agr: AgreementDto, file: ArrayBuffer) {
    let formData = new FormData();

    formData.append('file', new Blob([file]));
    for (let data of Object.keys(agr)) {
      formData.append(data, agr[data]);
    }
    return this.http.post<AgreementDto[]>(
      environment.host + '/agreements/poster-upload',
      formData,
    );
  }

  downloadAgreementPoster(agrId: number) {
    return this.http.get(environment.host + '/agreements/poster/' + agrId, {
      responseType: 'blob',
    });
  }
}
